import { render, staticRenderFns } from "./onboard.vue?vue&type=template&id=02771f78&scoped=true&"
import script from "./onboard.vue?vue&type=script&lang=js&"
export * from "./onboard.vue?vue&type=script&lang=js&"
import style0 from "./onboard.vue?vue&type=style&index=0&id=02771f78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02771f78",
  null
  
)

export default component.exports